import { AgentActionTypes } from "./types";
import { IAgent } from "../../models/agent.interface";
import { Dispatch } from "redux";
import { agentService } from "../../services/agent.services";

export interface AgentAction {
  type: AgentActionTypes;
  payload: IAgent | null;
}

export const agentActions = {
  getLogo: (agentCode: string) => {
    return async (dispatch: Dispatch) => {
      dispatch<AgentAction>({
        type: AgentActionTypes.GET_LOGO,
        payload: null
      });

      await agentService.getLogo(agentCode).then(response => {
        dispatch<AgentAction>({
          type: AgentActionTypes.GET_LOGO_COMPLETED,
          payload: response.data
        });
      }).catch(reason => {
      //  console.log(`Agent can't be found or there was an error - ${reason}`)
      });
    };
  }
};
